module.exports = __webpack_public_path__ + "static/img/33.53c50b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/33.png
// module id = +3WX
// module chunks = 0